import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260903_remove_last_session_info",
  description: "Remove lastSessionInfo; Studio keeps editor view state in localStorage instead",
  apply(json: any) {
    delete json.lastSessionInfo;
    return json;
  },
};

export default migration;
